import React, { memo } from 'react';

import { Tabs, TabsList, TabsTrigger } from '@mint-lib/tw-components';

import { NotificationTabs, TabType } from '../../../constants/Tabs.jsx';

type TabsType = {
  activeTab: NotificationTabs;
  tabList: TabType[];
  onTabChange(activeTab: NotificationTabs): void;
};

const IntegrationsTabs: React.FC<TabsType> = ({
  activeTab,
  onTabChange,
  tabList,
}) => {
  return (
    <div className="mt-2 flex">
      <Tabs orientation="horizontal" value={activeTab} className="w-full">
        <TabsList>
          {tabList.map((tab) => (
            <TabsTrigger
              data-testid={tab.id}
              key={tab.id}
              value={tab.id}
              size="large"
              disabled={tab.disabled}
              onClick={() => onTabChange(tab.id)}
              data-dd-action-name="change integration tab"
            >
              {tab.label}
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>
    </div>
  );
};

export default memo(IntegrationsTabs);
